import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const TypographyTypefaces = ({ fonts, setTypographyAssignments, typographyAssignments }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const typefaces = ["heading", "heading-alt", "body", "body-alt"];
  const weightOptions = ["light", "normal", "semi-bold", "bold", "extra-bold"];

  useEffect(() => {
    if (!fonts) {
      alert("Please Load Adobe Font Project First");
      return navigate(location.pathname.replace("typefaces", ""));
    }
  }, []);

  function parseFonts() {
    let dropDownValues = [""];

    if (fonts) {
      fonts.kit.families.map((item) => {
        const cssNames = item.css_names[0];
        dropDownValues = dropDownValues.concat(cssNames);
      });
    }
    return dropDownValues;
  }

  function parseFontWeights() {
    let values = [];

    if (fonts) {
      fonts.kit.families.map((item) => {
        const cssNames = item.css_names[0];
        const weights = [
          ...new Set(
            item.variations.map((variation) => {
              return variation.substring(1, 2) * 100;
            })
          ),
        ];

        values = values.concat({ fontName: cssNames, fontweights: weights });
      });
    }
    return values;
  }

  function handleTypefaceAssignment(typeface, e) {
    e.preventDefault();
    const newTypeface = { ...typographyAssignments, [typeface]: { value: e.target.value } };
    setTypographyAssignments(newTypeface);
  }

  function renderTypeFaces() {
    return typefaces.map((typeface) => {
      const dropDownValues = parseFonts();

      const selectData = dropDownValues.map((item) => {
        return (
          <option key={item} value={item}>
            {item}
          </option>
        );
      });

      return (
        <div className="typography-input-container" key={typeface}>
          <div className="typography-input-label">{typeface}</div>
          <select
            className="typography-input"
            onChange={(e) => handleTypefaceAssignment(typeface, e)}>
            {selectData}
          </select>
        </div>
      );
    });
  }

  function renderWeightAssignment() {
    const availableWeights = parseFontWeights();

    if (Object.values(typographyAssignments).length >= 4) {
      const renderedWeightOptions = typefaces.map((typeface) => {
        const typeFaceFontAssigned = typographyAssignments[typeface].value;
        const dropDownValues = [
          "",
          ...availableWeights.find((item) => item.fontName === typeFaceFontAssigned).fontweights,
        ];
        return weightOptions.map((weightOption) => {
          const selectData = dropDownValues.map((item) => {
            return (
              <option key={item} value={item}>
                {item}
              </option>
            );
          });

          return (
            <div className="typography-input-container" key={`${typeface}-${weightOption}`}>
              <div className="typography-input-label">{`${typeface}-${weightOption}`}</div>
              <select
                className="typography-input"
                onChange={(e) => handleTypefaceAssignment(typeface + "-" + weightOption, e)}>
                {selectData}
              </select>
            </div>
          );
        });
      });

      return (
        <>
          <div className="typography-typeface-weight-assigment-header">
            <h2>Now Assign Weights to each instance</h2>
          </div>
          <div className="typography-typeface-weight-assigment">{renderedWeightOptions}</div>
        </>
      );
    } else {
      return null;
    }
  }

  renderWeightAssignment();

  return (
    <div className="typography-typeface-header">
      <h3>Assign Typefaces Based on Imported Fonts</h3>
      <div className="typography-typeface-assignment">{renderTypeFaces()}</div>
      {renderWeightAssignment()}
    </div>
  );
};

export default TypographyTypefaces;
